/*
Defines and orders the full timeline.
*/

import "regenerator-runtime/runtime"; //async function
// setup
import {
  createPreloadTrials,
  initTrialSaving,
  initTimeline,
} from "../shared/helpers";
import { jsPsych } from "../taskSetup"; //initialised jspsych object
//import { preloadTrials } from "./helperFunctions"; //jspsych object for preloading media, function for initialising Cat class
import { intro, instructions, endTrialAlpaca } from "./trials/introduction";
import { ValidityEvaluator, createEvaluateValidity } from "@bdelab/roar-utils"; // for validity
import { exitFullscreen, endTrial } from "../shared/trials"; //jspsych object for exiting full screen
import { numberMainLoop } from "./trials/runCorpusTimeline";
import { preloadTrials } from "../..";

export let alpacaValidityEvaluator;

//calls the initializatin functions, builds the timeline
export default function buildAlpacaTimeline(config) {
  // jspsych object for preloading media assets into the browser
  //const preloadTrials = createPreloadTrials(mediaAssets).default;

  // initialising session data, writing data to firestore, event listener for errors
  initTrialSaving(config);

  // enter full screen, get user data (consent, survey, lab id, pid)
  const initialTimeline = initTimeline(config);

  const alpacaEvaluateValidity = createEvaluateValidity({
    responseTimeLowThreshold: 250,
    accuracyThreshold: 0.6,
    minResponsesRequired: 3,
    includedReliabilityFlags: ["responseTimeTooFast"],
  });

  const alpacaHandleEngagementFlags = (flags, reliable) => {
    if (config.firekit.run.started) {
      return config.firekit.updateEngagementFlags(flags, reliable);
    }
    return null;
  };

  alpacaValidityEvaluator = new ValidityEvaluator({
    evaluateValidity: alpacaEvaluateValidity,
    handleEngagementFlags: alpacaHandleEngagementFlags,
  });

  //preload media, enter full screen and get user data
  const timeline = [preloadTrials];
  timeline.push(initialTimeline);

  // add introduction screen
  timeline.push(intro);

  // add instructions screen
  timeline.push(instructions);

  timeline.push(numberMainLoop("stimulus", "test_response"));

  timeline.push(endTrialAlpaca); // End Task
  timeline.push(exitFullscreen);

  return { jsPsych, timeline };
}
